<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button @click="save('userForm')" class="pill next-pill-button" :disabled="formsData.userForm.disabled">
          <span>Save</span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <!-- <PageTitle title="Bank Account" subtitle="Bank Account Details" /> -->
        <div class="auth-header">
            <div class="auth-heading">
                <h1>Bank Account</h1>
                <p class="auth-subtext">Bank Account Details!</p>
            </div>
            <div class="brand-icon">
                <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
            </div>
        </div>
      <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')"
        @keyup.enter="goNext('userForm')">
        <el-form-item label="Bank Name" prop="bankName">
          <el-select popper-class="normal-select" style="width: 100%" filterable v-model="formsData.userForm.bankName.value" placeholder="Select Bank"
            @change="checkFormValidation('userForm', true, 'bankName')">
            <el-option v-for="item in banks" :key="item.id" :label="item.bankName" :value="item.bankName" />
          </el-select>
        </el-form-item>
        <el-form-item label="Account Name" prop="bankAccountName" :required="true">
          <el-input v-model="formsData.userForm.bankAccountName.value" :placeholder="'Account Name'"
            @change="checkFormValidation('userForm', true, 'bankAccountName')"
            @blur="checkFormValidation('userForm', true, 'bankAccountName')" @keyup="
              formsData.userForm.bankAccountName.value = $event.target.value
            "></el-input>
        </el-form-item>
        <el-form-item label="BSB" prop="bsb" :required="true">
          <div class="el-input">
            <input type="tel" class="el-input__inner" :value="formsData.userForm.bsb.value" :placeholder="'000000'"
              v-imask="formsData.userForm.bsb.mask" @accept="onFormMaskAccept($event, 'userForm', 'bsb')"
              @blur="checkFormValidation('userForm', true, 'bsb')" />
          </div>
        </el-form-item>
        <el-form-item label="Account Number" prop="bankAccountNumber" :required="true">
          <div class="el-input">
            <input type="tel" class="el-input__inner" :value="formsData.userForm.bankAccountNumber.value"
              :placeholder="'000000000000'" v-imask="formsData.userForm.bankAccountNumber.mask"
              @accept="onFormMaskAccept($event, 'userForm', 'bankAccountNumber')"
              @blur="checkFormValidation('userForm', true, 'bankAccountNumber')" />
          </div>
        </el-form-item>
    
      </el-form>
      <div class="bg-overlay"></div>
      </div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
  </div>
</template>
<script>
import { onMounted, ref } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline, downloadOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
  "download-outline": downloadOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

import { useRouter } from "vue-router";
import { useStore } from "vuex";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";
// import PageTitle from "@/components/PageTitle/PageTitle.vue";
export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const banks = ref([]);
    const billing = userData.billing;
    const formsDataArray = {
      userForm: {
        isFormValid: true,
        bankName: {
          value: userData.bankNameBilling ? userData.bankNameBilling : null,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bankName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        bankAccountName: {
          value: billing.bankAccountName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bankAccountName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        bsb: {
          value: billing.bankBsb
            ? IMask.createMask(formMasks.bsb).resolve(billing.bankBsb)
            : "",
          mask: formMasks.bsb,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bsb",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        bankAccountNumber: {
          value: billing.bankAccountNumber
            ? IMask.createMask(formMasks.bankAccountNumber).resolve(
              billing.bankAccountNumber
            )
            : "",
          mask: formMasks.bankAccountNumber,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bankAccountNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    async function getBanks() {
      const allBanks = await $store.dispatch("GET_ALL_BANK");
      banks.value = allBanks.data;
    }

    const save = (formName) => {
      console.log("formname", formsRefs[formName].value);
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              // checkFormChanged("userForm", true);
              await $store.dispatch(
                "SAVE_USER_BANK_INFORMATION",
                getFormValues(formName)
              );

              $router.push({
                name: "bank_account_verify",
              });
            } catch (error) {
              setFieldError(formName, "confirm", error.message);
              validateAllFields();
              console.log(error);
            }
          })();
        } else {
          validateAllFields();
          console.log("error submit!!");
          return false;
        }
      });
    };

    const {
      ["onFormMaskAccept"]: onFormMaskAccept,
      checkFormValidation,
      setFormValidation, // eslint-disable-line no-unused-vars
      setFormRefs,
      // checkFormChanged,
      getFormValues,
      setFieldError,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    const bankFormFields = ['bankName', 'bankAccountName', 'bsb', 'bankAccountNumber'];

    const validateAllFields = () => {
      bankFormFields.forEach((field) => {
        checkFormValidation('userForm', false, field);
      });
    };

    onMounted(() => {
      setFormRefs();
      getBanks();
      validateAllFields();
    });

    return {
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      save,
      userData,
      banks,
      userRole,
    };
  },
};
</script>